import { render, staticRenderFns } from "./XDeleteItemButton.vue?vue&type=template&id=dbf30ec0"
import script from "./XDeleteItemButton.vue?vue&type=script&lang=js"
export * from "./XDeleteItemButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports